import { useEventListener } from "@grandvisionhq/utils";
const miniCartEventType = "mini-cart";
const dispatchMiniCartEvent = (type, lineItems, cartId, cartHash) => {
  if (window) {
    window.dispatchEvent(
      new CustomEvent(miniCartEventType, {
        detail: {
          type,
          lineItems,
          cartId,
          cartHash
        }
      })
    );
  }
};
const useMiniCartListener = (handler) => {
  return useEventListener(miniCartEventType, handler);
};
export {
  dispatchMiniCartEvent,
  miniCartEventType,
  useMiniCartListener
};
//# sourceMappingURL=event.js.map
